module.exports = __webpack_public_path__ + "static/media/logo_coopbank.469fe83a.svg";